(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marevaka-home-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marevaka-journal-carousel')) {
    customElements.define('marevaka-journal-carousel', class extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('scroll-carousel');
        this.previousButton = this.querySelector('carousel-prev-button button');
        this.nextButton = this.querySelector('carousel-next-button button');
        if (!this.carousel || !this.previousButton || !this.nextButton) return;
        this.abortController = new AbortController();
        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.carousel);
        if (this.carousel.firstElementChild) this.resizeObserver.observe(this.carousel.firstElementChild);
        this.carousel.addEventListener('scroll', this.scheduleUpdate, {
          passive: true,
          signal: this.abortController.signal
        });
        ['scroll:edge-nearing', 'scroll:edge-leaving', 'carousel:settle'].forEach(eventName => {
          this.carousel.addEventListener(eventName, this.scheduleUpdate, {
            signal: this.abortController.signal
          });
        });
        customElements.whenDefined('scroll-carousel').then(() => {
          if (this.isConnected) this.scheduleUpdate();
        });
        this.scheduleUpdate();
      }

      updateControls() {
        if (!this.isConnected) return;
        const maximum = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
        const position = Math.abs(this.carousel.scrollLeft);
        this.classList.toggle('has-overflow', maximum > 1);
        this.previousButton.disabled = maximum <= 1 || position <= 1;
        this.nextButton.disabled = maximum <= 1 || position >= maximum - 1;
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
